{
  "properties.title": "Properties",
  "properties.count": "{count, plural, one {# property} other {# properties}}",
  "properties.new": "New property",
  "properties.search_label": "Search properties",
  "properties.search_placeholder": "Reference, place or title",
  "properties.kind": "Type",
  "properties.any_kind": "All types",
  "properties.any_status": "All statuses",
  "properties.attention": "Attention",
  "properties.attention_any": "Everything",
  "properties.attention_not_ready": "Not publishable yet",
  "properties.attention_rights": "Website right missing",
  "properties.attention_stale": "Outdated translations",
  "properties.sort": "Sort",
  "properties.sort_updated": "Last changed",
  "properties.sort_reference": "Reference",
  "properties.sort_price_desc": "Price, high to low",
  "properties.sort_price_asc": "Price, low to high",
  "properties.clear_filters": "Clear filters",
  "properties.col_photo": "Photo",
  "properties.col_property": "Property",
  "properties.col_price": "Price",
  "properties.col_status": "Status",
  "properties.col_facts": "Facts",
  "properties.col_attention": "Attention",
  "properties.col_updated": "Changed",
  "properties.untitled": "No title yet",
  "properties.on_request": "On request",
  "properties.beds": "{count, plural, =0 {No bedrooms} one {# bed} other {# beds}}",
  "properties.baths": "{count, plural, one {# bath} other {# baths}}",
  "properties.signal_rights": "No valid website right: will not be published",
  "properties.signal_photos": "No photos yet",
  "properties.signal_stale": "{count, plural, one {# translation outdated} other {# translations outdated}}",
  "properties.signal_pending": "{count, plural, one {# translation awaiting review} other {# translations awaiting review}}",
  "properties.signal_none": "All in order",
  "properties.empty_title": "No properties yet",
  "properties.empty_body": "Create a property or import your listings via Imports.",
  "properties.empty_filtered_title": "No properties match these filters",
  "properties.empty_filtered_body": "Adjust or clear the filters to see everything.",
  "properties.bulk_label": "Bulk actions",
  "properties.bulk_actions": "Change",
  "properties.bulk_set_status": "Set status to",
  "properties.bulk_set_editorial": "Editorial status",
  "properties.bulk_other": "Other",
  "properties.bulk_price": "Adjust price by a percentage",
  "properties.bulk_price_title": "{count, plural, one {Adjust the price of # property} other {Adjust the prices of # properties}}",
  "properties.bulk_price_body": "Every asking price goes up or down by the same percentage. Properties with price on request stay unchanged.",
  "properties.bulk_price_percent": "Percentage",
  "properties.bulk_price_hint": "Between −50 and 50. Use a minus for a reduction.",
  "properties.bulk_price_apply": "Adjust prices",
  "properties.bulk_done": "{ok, plural, =0 {Nothing changed} one {# property updated} other {# properties updated}}",
  "properties.bulk_failed": "{failed, plural, one {# property not changed; open it to see why.} other {# properties not changed; open them to see why.}}",
  "properties.new_title": "New property",
  "properties.new_body": "Start with the basics. Add photos, texts and rights in the record afterwards.",
  "properties.reference": "Reference",
  "properties.reference_hint": "Unique within your organisation, for example TB-4210.",
  "properties.offer_kind": "Offer",
  "properties.price": "Asking price",
  "properties.price_hint": "Leave empty for price on request.",
  "properties.locality": "Place",
  "properties.new_submit": "Create property",
  "properties.created": "{reference} created as draft",
  "editor.add_grant": "Record a right",
  "editor.add_link": "Add link",
  "editor.add_lock": "Lock a field",
  "editor.advice": "Advice",
  "editor.archive": "Archive",
  "editor.area": "Area",
  "editor.area_hint": "Decides which area page the property appears on.",
  "editor.area_none": "No area",
  "editor.basis": "Basis",
  "editor.bathrooms": "Bathrooms",
  "editor.bedrooms": "Bedrooms",
  "editor.blocking": "Blocks publication",
  "editor.blocking_count": "{count, plural, one {# issue blocks publication} other {# issues block publication}}",
  "editor.built": "Built area",
  "editor.cadastral_ref": "Cadastral reference",
  "editor.changed": "Changed {when}",
  "editor.channel": "Channel",
  "editor.channel_hint": "For example idealista or kyero. Empty means all portals.",
  "editor.chars": "{count} of {max} characters",
  "editor.choose_files": "Choose files",
  "editor.commission_note": "Commission arrangements",
  "editor.community_fee": "Community fees per year",
  "editor.conflict_title": "Changed by someone else in the meantime",
  "editor.conflict_body": "You were working on version {yours}; the property is now at version {current}. Choose what happens to your changes.",
  "editor.conflict_later": "Do nothing yet",
  "editor.conflict_reload": "Discard my changes",
  "editor.conflict_overwrite": "{count, plural, one {Save my change anyway} other {Save my # changes anyway}}",
  "editor.conflict_yours": "Your changes: {fields}",
  "editor.cover": "Cover",
  "editor.cover_set": "Cover photo chosen",
  "editor.current": "current",
  "editor.description": "Description",
  "editor.description_hint": "Facts such as price and size are checked automatically in translations.",
  "editor.discard": "Discard changes",
  "editor.duplicate": "Duplicate",
  "editor.duplicate_title": "Duplicate {reference}",
  "editor.duplicate_body": "Copies facts, price and texts into a new draft. Photos, rights and translations are not copied.",
  "editor.duplicate_submit": "Create copy",
  "editor.duplicated": "{reference} created as a copy",
  "editor.edit_rights": "Edit image rights",
  "editor.energy_consumption": "Consumption",
  "editor.energy_rating": "Energy rating",
  "editor.energy_status": "Energy certificate",
  "editor.evidence": "Evidence or reference",
  "editor.evidence_hint": "For example the mandate number or the date of the email.",
  "editor.fix": "Fix",
  "editor.floor": "Floor",
  "editor.floorplan": "Floor plan",
  "editor.generated": "Generated",
  "editor.grant_added": "Right recorded",
  "editor.grant_body": "Without a valid website right the property is not published.",
  "editor.grant_submit": "Record right",
  "editor.history": "Versions",
  "editor.key_instructions": "Keys and access",
  "editor.last_seen": "last seen {when}",
  "editor.leave_title": "Changes not saved",
  "editor.leave_body": "{count, plural, one {You have # change that is not saved yet.} other {You have # changes that are not saved yet.}}",
  "editor.leave_confirm": "Leave without saving",
  "editor.leave_stay": "Stay",
  "editor.link_added": "Link added",
  "editor.link_url": "Address",
  "editor.link_url_hint": "Only https links.",
  "editor.links_title": "Video and tour",
  "editor.live_revision": "Live in revision {revision}, {when}",
  "editor.loc_missing": "Missing",
  "editor.locality": "Place",
  "editor.lock_body": "A locked group is not overwritten by imports.",
  "editor.lock_reason_hint": "For example: price agreed with owner, feed is behind.",
  "editor.lock_submit": "Lock",
  "editor.lock_which": "Which data",
  "editor.locked": "Locked for imports",
  "editor.locks": "Locked for imports",
  "editor.locks_hint": "Manual corrections stay, even when a feed reports something else.",
  "editor.make_cover": "Use as cover",
  "editor.mark_ready": "Mark as ready",
  "editor.media_actions": "Actions for this image",
  "editor.media_removed": "Image removed",
  "editor.media_reordered": "Order saved",
  "editor.media_type": "Type",
  "editor.meta_description": "Search engine text",
  "editor.meta_hint": "Short summary for Google. Leave empty to use the first sentence of the description.",
  "editor.missing_since": "missing from feed since {when}",
  "editor.municipality": "Municipality",
  "editor.never_published": "Not published yet",
  "editor.new_reference": "New reference",
  "editor.no_field_changes": "No field changes",
  "editor.no_files": "No files chosen yet. You can also drop them on the photo grid.",
  "editor.no_history": "No versions yet",
  "editor.no_links": "No video or virtual tour.",
  "editor.no_locks": "Nothing locked.",
  "editor.no_offer_title": "No active offer",
  "editor.add_offer": "Add offer",
  "editor.no_photos_title": "No photos yet",
  "editor.no_photos_body": "Drop photos here or choose files. At least 800 × 500 pixels.",
  "editor.no_portals_title": "Not on portals",
  "editor.no_portals_body": "Once a portal feed includes this property, you see the delivery status here.",
  "editor.no_rights_title": "No rights recorded",
  "editor.no_rights_body": "Record on what basis you may show this property on the website and portals.",
  "editor.no_sources": "Entered manually; no external source linked.",
  "editor.no_translations": "No translations yet.",
  "editor.not_publishable": "{count, plural, one {Not publishable yet: # issue} other {Not publishable yet: # issues}}",
  "editor.not_publishable_body": "A publication skips this property until the red issues are fixed.",
  "editor.open_ended": "open-ended",
  "editor.open_queue": "Go to the translation queue",
  "editor.open_site": "Open website",
  "editor.orientation": "Orientation",
  "editor.ownership": "Listing type",
  "editor.period": "Period",
  "editor.photo": "Photo",
  "editor.photos_hint": "Drag to change the order. The first photos appear at the top of the website.",
  "editor.photos_label": "Photos and floor plans",
  "editor.photos_title": "{count, plural, =0 {Photos} one {# image} other {# images}}",
  "editor.plot": "Plot",
  "editor.portals": "Portals",
  "editor.postal_code": "Postcode",
  "editor.precision": "Show location as",
  "editor.precision_hint": "The exact address never appears on the website.",
  "editor.price_on_request": "Price on request",
  "editor.private_note": "Internal only. These details never go to the website or portals.",
  "editor.property_tax": "Property tax (IBI) per year",
  "editor.province": "Province",
  "editor.publishable": "Ready to publish",
  "editor.publishable_body": "All required data, photos and rights are present.",
  "editor.publishable_with_advice": "There is still advice, but nothing blocks.",
  "editor.readiness": "Publication check",
  "editor.reason": "Reason",
  "editor.reason_hint": "At least 3 characters; goes into the history.",
  "editor.remove_title": "Remove image?",
  "editor.remove_body": "The image disappears at the next website publication.",
  "editor.remove_cover_body": "The first remaining photo becomes the cover.",
  "editor.move_media": "Move image",
  "editor.remove_confirm": "Remove image",
  "editor.remove_media": "Remove",
  "editor.rent": "Rent",
  "editor.restore": "Restore",
  "editor.restore_title": "Restore version {version}?",
  "editor.restore_body": "The data of that version becomes a new version. Nothing is lost.",
  "editor.restore_dirty": "Your unsaved changes will be lost. The data of that version becomes a new version.",
  "editor.restore_confirm": "Restore version {version}",
  "editor.restored": "Version {version} restored",
  "editor.revoke": "Revoke",
  "editor.revoke_title": "Revoke right?",
  "editor.revoke_body": "The property is withdrawn there at the next portal feed.",
  "editor.revoke_website_title": "Revoke website right?",
  "editor.revoke_website_body": "The property disappears from the live website immediately: its address then reports that the property is no longer offered.",
  "editor.revoke_website_confirm": "Remove from website now",
  "editor.revoked": "Right revoked",
  "editor.revoked_website": "Revoked and removed from the website",
  "editor.rights_body": "Record where this image comes from and where you may use it.",
  "editor.rights_channels": "May be used on",
  "editor.rights_channels_hint": "Only the chosen channels receive this image.",
  "editor.rights_credit": "Photographer or source",
  "editor.rights_generated_note": "The image remains identified as generated.",
  "editor.generation_note": "Tool and method",
  "editor.edit_alt": "Edit alt text",
  "editor.alt_body": "Approval under Languages is required before publishing.",
  "editor.alt_source": "Image description ({locale})",
  "editor.alt_locale": "Language",
  "editor.alt_saved": "Alt text saved for review",
  "editor.rights_grants": "Rights",
  "editor.rights_license": "Licence",
  "editor.rights_license_hint": "State the licence number or a link to the terms.",
  "editor.rights_saved": "Image rights saved",
  "editor.rights_source": "Origin",
  "editor.rights_title": "Image rights",
  "editor.rights_unknown": "Origin unknown",
  "editor.save_bar": "Save",
  "editor.saved": "Saved as version {version}",
  "editor.saved_stale": "{count, plural, one {# translation is now outdated and needs an update.} other {# translations are now outdated and need an update.}}",
  "editor.scope": "For",
  "editor.section_basics": "Basics",
  "editor.section_costs": "Running costs",
  "editor.section_energy": "Energy and licences",
  "editor.section_features": "Features and views",
  "editor.section_location": "Location",
  "editor.section_offer": "Offer",
  "editor.section_private": "Internal",
  "editor.sold_note": "Sold and let properties stay on the website as a reference, without an enquiry form.",
  "editor.source_agency": "Source agency",
  "editor.source_texts": "Source text ({locale})",
  "editor.sources": "Sources",
  "editor.street_address": "Street address",
  "editor.tab_facts": "Details",
  "editor.tab_history": "Versions",
  "editor.tab_media": "Photos",
  "editor.tab_offer": "Price and status",
  "editor.tab_publish": "Publication",
  "editor.tab_rights": "Rights and sources",
  "editor.tab_texts": "Texts",
  "editor.tabs": "Parts of the record",
  "editor.terrace": "Terrace",
  "editor.texts_stale_warning": "After saving, existing translations of this text are marked as outdated.",
  "editor.title": "Title",
  "editor.tourist_license": "Tourist licence",
  "editor.translations": "Translations",
  "editor.unlock": "Unlock",
  "editor.unlocked": "Unlocked",
  "editor.unsaved": "{count, plural, one {# unsaved change} other {# unsaved changes}}",
  "editor.upload": "Upload",
  "editor.upload_title": "Upload images",
  "editor.upload_body": "JPEG, PNG, WebP or AVIF up to 25 MB, at least 800 × 500 pixels. Floor plans and PDF documents are fine too.",
  "editor.upload_submit": "{count, plural, =0 {Upload} one {Upload # file} other {Upload # files}}",
  "editor.uploaded": "{count, plural, one {# image added} other {# images added}}",
  "editor.usable": "Usable area",
  "editor.valid_range": "valid {from} to {until}",
  "editor.valid_until": "Valid until",
  "editor.views": "Views",
  "editor.websites": "Website",
  "editor.year_built": "Year built",
  "editor.delivery.generated": "Generated",
  "editor.delivery.sent": "Sent",
  "editor.delivery.fetched": "Fetched",
  "editor.delivery.accepted": "Accepted",
  "editor.delivery.rejected": "Rejected",
  "editor.delivery.withdrawn": "Withdrawn",
  "editor.delivery.unknown": "Unknown",
  "editor.field_group.identity": "Type and reference",
  "editor.field_group.location": "Location",
  "editor.field_group.facts": "Facts",
  "editor.field_group.price": "Price",
  "editor.field_group.status": "Status",
  "editor.field_group.energy": "Energy",
  "editor.field_group.media": "Photos",
  "editor.field_group.description": "Texts",
  "editor.source_kind.manual": "Manual",
  "editor.source_kind.import": "Import",
  "editor.source_kind.owner": "Owner",
  "editor.source_kind.inspection": "On-site inspection",
  "editor.source_kind.seed": "Demo data",
  "editor.grant_state.active": "Valid",
  "editor.grant_state.revoked": "Revoked",
  "editor.grant_state.expired": "Expired",
  "editor.grant_state.future": "Not valid yet",
  "editor.loc_status.draft": "Draft",
  "editor.loc_status.proposed": "Proposed",
  "editor.loc_status.in_review": "In review",
  "editor.loc_status.approved": "Approved",
  "editor.loc_status.rejected": "Rejected",
  "editor.loc_status.stale": "Outdated",
  "editor.loc_status.superseded": "Superseded",
  "editor.lock_field.price": "Price",
  "editor.lock_field.status": "Status",
  "editor.lock_field.facts": "Facts",
  "editor.lock_field.location": "Location",
  "editor.lock_field.description": "Texts",
  "editor.lock_field.media": "Photos",
  "editor.lock_field.identity": "Type and reference",
  "editor.media_kind.photo": "Photo",
  "editor.media_kind.floorplan": "Floor plan",
  "editor.media_kind.document": "Document (PDF)",
  "editor.media_kind.video_link": "Video",
  "editor.media_kind.tour_link": "Virtual tour",
  "editor.source.manual": "Manual",
  "editor.source.bulk": "Bulk action",
  "editor.source.import": "Import",
  "editor.source.restore": "Restored",
  "editor.source.seed": "Demo data",
  "editor.source.create": "Created",
  "editor.field.kind": "type",
  "editor.field.bedrooms": "bedrooms",
  "editor.field.bathrooms": "bathrooms",
  "editor.field.builtM2": "built area",
  "editor.field.usableM2": "usable area",
  "editor.field.plotM2": "plot",
  "editor.field.terraceM2": "terrace",
  "editor.field.yearBuilt": "year built",
  "editor.field.floorLevel": "floor",
  "editor.field.orientation": "orientation",
  "editor.field.views": "views",
  "editor.field.features": "features",
  "editor.field.energyStatus": "energy certificate",
  "editor.field.energyRating": "energy rating",
  "editor.field.energyConsumption": "consumption",
  "editor.field.touristLicense": "licence",
  "editor.field.locality": "place",
  "editor.field.municipality": "municipality",
  "editor.field.areaId": "area",
  "editor.field.precision": "location display",
  "editor.field.amountMinor": "price",
  "editor.field.status": "status",
  "editor.field.priceOnRequest": "price on request",
  "editor.field.title": "title",
  "editor.field.description": "description",
  "editor.field.metaDescription": "search text",
  "editor.field.editorialStatus": "editorial status",
  "editor.field.reference": "reference",
  "editor.field.offer.amountMinor": "price",
  "editor.field.offer.status": "status",
  "editor.issue.facts.no_bedrooms_for_kind": "This type of property has no bedrooms.",
  "editor.issue.facts.studio_has_no_bedrooms": "A studio has no separate bedrooms.",
  "editor.issue.facts.usable_exceeds_built": "Usable area is larger than built area.",
  "editor.issue.facts.energy_rating_required": "Choose the energy rating for a certified property.",
  "editor.issue.facts.year_built_future": "Year built is in the future.",
  "editor.issue.ready.offer_missing": "There is no active sale or rental.",
  "editor.issue.ready.price_missing": "Enter a price or choose price on request.",
  "editor.issue.ready.location_missing": "Enter the place or municipality.",
  "editor.issue.ready.area_missing": "Choose an area so the property also appears on the area page.",
  "editor.issue.ready.bedrooms_unknown": "Number of bedrooms unknown.",
  "editor.issue.ready.bathrooms_unknown": "Number of bathrooms unknown.",
  "editor.issue.ready.built_unknown": "Built area unknown.",
  "editor.issue.ready.plot_unknown": "Enter the plot size.",
  "editor.issue.ready.photos_few": "{count, plural, =0 {No photos yet; at least 3 recommended.} one {Only # photo; at least 3 recommended.} other {Only # photos; at least 3 recommended.}}",
  "editor.issue.ready.cover_missing": "Choose a cover photo.",
  "editor.issue.ready.website_right_missing": "Record a valid website right.",
  "editor.issue.ready.energy_unknown": "Energy certificate unknown.",
  "editor.issue.ready.title_missing": "Write a title.",
  "editor.issue.ready.description_missing": "Write a description.",
  "editor.issue.ready.editorial_not_ready": "Set the dossier status to Ready to publish.",
  "editor.issue.ready.title_unapproved": "Have the source title approved under Languages.",
  "editor.issue.ready.description_unapproved": "Have the source description approved under Languages.",
  "properties.view": "View",
  "properties.view_list": "List",
  "properties.view_grid": "Gallery",
  "properties.photos": "{count, plural, =0 {No photos} one {# photo} other {# photos}}",
  "properties.updated_title": "Updated {date}",
  "properties.ready_hint": "Ready to publish",
  "properties.per_month": " /mo",
  "properties.per_week": " /wk",
  "editor.changed_short": "Updated",
  "editor.ready_ok": "Ready to publish",
  "editor.dirty_tab": "Unsaved changes",
  "editor.draft_restored": "Unsaved changes restored",
  "editor.uploads_label": "Uploads",
  "editor.upload_tile_queued": "Waiting",
  "editor.upload_tile_busy": "Uploading",
  "editor.upload_tile_failed": "Not uploaded",
  "editor.feature_group.outdoor": "Outdoor",
  "editor.feature_group.parking": "Parking and storage",
  "editor.feature_group.comfort": "Comfort and installations",
  "editor.feature_group.setting": "Setting",
  "editor.feature_group.other": "Other",
  "editor.feature_group_count": "{group} · {count} selected"
}
